"use client";

const Footer = () => {
  return (
    <>
      <div className="flex-grow-1"></div>

      <footer className="footer-area bg-white text-center rounded-top-7">
        <p className="fs-14">
          © <span className="text-primary-div">Time Sync</span> is Proudly Owned by{" "}
            IT Lab Solutions Ltd.
        </p>
      </footer>
    </>
  );
};

export default Footer;
